import { useEffect, useState } from "react";
import { SuccessTick } from "components/assets/Icons";
import { useNavigate } from "react-router-dom";

import styles from "./styles.module.scss";

const PopUpSuccess = ({ text }) => {
  const navigate = useNavigate()
  const [hidePopUp, setHidePopUp] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/trucks')
      setHidePopUp(true)
    }, 4000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    !hidePopUp && (
      <div className={styles.wrapper}>
        <SuccessTick />
        <div className={styles.content}>
          <h2 className={styles.title}>Success!</h2>
          <p className={styles.message}>{text}</p>
        </div>
      </div>
    )
  );
};

export default PopUpSuccess;
